<template>
  <div
    class="container-fluid mycontainer-fluid content"
    v-if="$parent.rerender"
  >
    <a ref="target" id="target"></a>
    <div class="content-title content-mb-14">
      18. Цели и показатели проекта
    </div>
    <fieldset
      :disabled="isIndicatorCoordinated"
      style="border: 0; padding: 0; margin: 0;"
    >
      <target_years></target_years>
    </fieldset>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_DIRECTORIES } from "@/store/actions.type";
import Target_years from "@/components/project/form/partial/target_years";

export default {
  name: "step_planned-indicators_lizing_ships",
  props: ["step", "project"],
  components: {
    Target_years
  },
  data() {
    return {
      // выставляется из target_years через applyIndicatorActions
      RESULT_INTELLECTUAL_ACTIVITY: false
    };
  },
  async created() {
    await this.$store.dispatch(FETCH_DIRECTORIES, [
      "program_fin_support",
      "regions",
      "start_pokazatel"
    ]);
  },
  computed: {
    ...mapGetters(["directory"]),
    isIndicatorCoordinated() {
      const list = this.project && this.project.COORDINATIONS;
      if (!Array.isArray(list)) {
        return false;
      }
      return list.some(
        el =>
          el &&
          el.UF_TYPE_PAGE === "indicator_project_10_01" &&
          (el.UF_IS_COORDINATION == 1 || el.UF_IS_COORDINATION === true)
      );
    }
  }
};
</script>

<style scoped></style>
